import * as React from 'react';
import type { useQuizResultActions } from '@mentimeter/quiz';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import type { QuizPlayerScore } from '@mentimeter/quiz-types';
import { MasonryGrid } from '@mentimeter/slides-presentation-ui/masonry-grid';
import { useTranslations } from 'next-intl';
import { groupAnswers } from '../utils';
import { Card } from '../card/Card';

const NUMBER_OF_COLUMNS = 3;

export const Results = ({
  results,
  onMarkAnswer,
  isReadonly,
}: {
  onMarkAnswer:
    | ReturnType<typeof useQuizResultActions>['markAnswer']
    | undefined;
  results: QuizPlayerScore[] | undefined;
  isReadonly: boolean;
}) => {
  const translate = useTranslations('presenting.legacy');

  const groupedResults = React.useMemo(() => {
    return groupAnswers(results ?? []);
  }, [results]);

  if (results === undefined) {
    return (
      <Box
        flex="1 1 auto"
        width="100%"
        height="100%"
        alignItems="center"
        justifyContent="center"
      >
        <Text color="text" fontSize="125">
          {translate('message.loading')}
        </Text>
      </Box>
    );
  }
  return (
    <Box
      width="100%"
      height="100%"
      overflow="scroll"
      pb="10%"
      data-testid="quiz-open-results"
    >
      <MasonryGrid numberOfColumns={NUMBER_OF_COLUMNS} shouldAnimate={false}>
        {groupedResults.map(
          (
            { identifiers, answer, markedCorrect, markedInappropriate },
            index,
          ) => (
            <Card
              key={answer}
              index={index}
              correct={markedCorrect}
              blurred={markedInappropriate}
              onMarkAnswer={onMarkAnswer}
              answer={answer}
              identifiers={identifiers}
              isReadOnly={isReadonly}
            />
          ),
        )}
      </MasonryGrid>
    </Box>
  );
};
